'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _components = require('components');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _support = require('helpers/support');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ReactGA from 'react-ga';

var BookingPromotionScreen = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST,
    voucherFilters: state.voucher.voucherFilters,
    voucherFilterChosen: state.voucher.voucherFilterChosen,
    submit: state.shops.submit,
    shop: state.shops.shop
  };
}, {
  getMyReward: voucherActions.getMyReward,
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  changeVoucherFilter: voucherActions.changeVoucherFilter,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  showDownloadAppPopup: setupActions.showDownloadAppPopup,
  setPathName: _setup.setPathName
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BookingPromotionScreen, _Component);

  function BookingPromotionScreen(props) {
    (0, _classCallCheck3.default)(this, BookingPromotionScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BookingPromotionScreen.__proto__ || (0, _getPrototypeOf2.default)(BookingPromotionScreen)).call(this, props));

    _this.state = {
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'warn' },
        message: [],
        button: []
      }
    };

    _this.renderMyReward = _this.renderMyReward.bind(_this);
    _this.hideFlow = _this.hideFlow.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(BookingPromotionScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.MY_REWARD_LIST.data.length === 0) {
        this.props.getMyReward();
      }
      if (this.props.route.path === 'uu-dai-toi') {
        this.props.changeVoucherFilter('Ưu đãi của tôi');
      }
    }
  }, {
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card from My Reward',
        label: '' + code
      });
    }
  }, {
    key: 'showFlow',
    value: function showFlow() {
      this.setState({ showFlow: true });
    }
  }, {
    key: 'hideFlow',
    value: function hideFlow() {
      this.setState({ showFlow: false });
    }
  }, {
    key: 'downApp',
    value: function downApp(platform) {
      if (platform === 'ios') {
        window.location.assign(_config2.default.iosLink);
      }
      if (platform === 'android') {
        window.location.assign(_config2.default.androidLink);
      }
    }
  }, {
    key: 'onBooking',
    value: function onBooking(e, item) {
      this.props.showDownloadAppPopup();
      // const { code, shop, service, notSupportOn } = item;
      // const {
      //   resetBooking,
      //   setDefaultBooking,
      //   history,
      //   user,
      //   changeShopBeforeBooking,
      // } = this.props;
      // e.stopPropagation();
      // if (notSupportOn && notSupportOn.indexOf('web') !== -1) {
      //   const contentFlow = { ...MODAL_CUSTOM.REWARD_FOR_APP };
      //   contentFlow.button = [
      //     {
      //       iconFont: 'fa fa-apple fa-3x',
      //       text: 'IOS',
      //       onClick: () => {
      //         this.downApp('ios');
      //       },
      //     },
      //     {
      //       iconFont: 'fa fa-android fa-3x',
      //       text: 'Android',
      //       onClick: () => {
      //         this.downApp('android');
      //       },
      //     },
      //   ];
      //   this.setState({ showFlow: true, contentFlow });
      //   return;
      // }
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = { bookingServices, code, shop };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
      // if (user) {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button',
      //     label: `${code}`,
      //   });
      //   ReactGA.event({
      //     category: 'Booking',
      //     action: 'Clicked To Step 1 (General Voucher)',
      //     label: `${shop.name}`,
      //   });
      // } else {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button (not logged in)',
      //     label: `${code}`,
      //   });
      // }
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      this.props.setPathName('/uu-dai');
      this.props.history.push('/dang-nhap');
    }
  }, {
    key: 'renderMyReward',
    value: function renderMyReward(item, i) {
      var _this2 = this;

      var _item = _support.Helper.parseMyVoucherToCard(item);
      return _react2.default.createElement(_components.RewardItemSmall, {
        key: 'serviceItem_' + i,
        item: _item,
        isMyVoucher: true,
        onPress: function onPress() {
          return _this2.toBookingReward(_item.code);
        },
        onExchange: function onExchange(e) {
          return _this2.onBooking(e, _item);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          history = _props.history,
          data = _props.MY_REWARD_LIST.data,
          user = _props.user,
          route = _props.route,
          voucherFilters = _props.voucherFilters,
          voucherFilterChosen = _props.voucherFilterChosen;
      var _state = this.state,
          contentFlow = _state.contentFlow,
          showFlow = _state.showFlow;

      var styles = require('./BookingPromotionScreen.scss');
      var hideCategory = true;
      var botInfo = null;
      if (user && user.rank) {
        botInfo = _Constant2.default.RANK[user.rank];
        botInfo.pointReward = user.rewardPoints;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.allReward },
        !hideCategory && _react2.default.createElement(
          'div',
          { className: styles.slider },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-cham-soc-da-massage' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.massageIcon }),
              'Ch\u0103m S\xF3c Da/Massage'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-lam-toc-mong' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.hairIcon }),
              'L\xE0m T\xF3c/M\xF3ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-tham-my-vien' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.cosmeticIcon }),
              'Th\u1EA9m M\u1EF9 Vi\u1EC7n'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-phong-kham' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.clinicIcon }),
              'Ph\xF2ng Kh\xE1m'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-the-duc-the-thao' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.fitnessIcon }),
              'Th\u1EC3 D\u1EE5c Th\u1EC3 Thao'
            )
          )
        ),
        _react2.default.createElement(_components.VoucherFilterBar, {
          voucherFilterChosen: voucherFilterChosen,
          voucherFilters: voucherFilters,
          history: history,
          route: route,
          changeVoucherFilter: this.props.changeVoucherFilter
        }),
        user ? _react2.default.createElement(
          'div',
          { className: '' + styles.listVoucher },
          !!(data && data.length) ? data.map(function (item, i) {
            return _this3.renderMyReward(item, i);
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i b\u1EA1n ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.requireLogin },
          'B\u1EA1n c\u1EA7n',
          ' ',
          _react2.default.createElement(
            'span',
            { className: styles.btnLogin, onClick: function onClick() {
                return _this3.toLogin();
              } },
            '\u0111\u0103ng nh\u1EADp'
          ),
          ' ',
          '\u0111\u1EC3 xem th\xF4ng tin n\xE0y'
        ),
        botInfo && _react2.default.createElement(_components.BottomInfoUser, { data: botInfo }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: this.hideFlow,
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        })
      );
    }
  }]);
  return BookingPromotionScreen;
}(_react.Component), _class2.propTypes = {
  // @data
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  route: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  voucherFilters: _react.PropTypes.array,
  voucherFilterChosen: _react.PropTypes.string,
  homeOff: _react.PropTypes.bool,
  // @action
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  setPathName: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  loadServiceOfHomeService: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  changeVoucherFilter: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = BookingPromotionScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/BookingPromotionScreen.js
// module id = 1624
// module chunks = 0